<ion-content>
  <ion-row text-center>
    <img class="header-icon" src="assets/old/images/check-mark.svg" />
    <!-- <ion-icon class="header-icon" name="checkmark-circle"></ion-icon> -->
  </ion-row>

  <div class="details">
    <div>{{ translation.Payment.PayWithin20Minutes | translate }}</div>
    <div>{{ translation.Payment.Request | translate }} : {{ identifier }}</div>
    <div class="saddadLabel">{{ translation.Payment.SadadInvoiceNumber | translate }}</div>
    <div>
      <ion-label class="saddadNo">
        <img class="imgIcon" src="assets/old/images/copy.svg" (click)="copyBillNumber(bill)" />
        <input #bill [(ngModel)]="billNumber" readonly />
      </ion-label>
    </div>
  </div>

  <ion-row>
    <ion-button class="confirm-btn" (click)="close(true)">{{ translation.Payment.Agree | translate }}</ion-button>
  </ion-row>
</ion-content>
